import CryptoJS from "crypto-js";

export const encrypt = (args) => {
  try {
    if (args) {
      const ciphertext = CryptoJS.AES.encrypt(args, process.env.REACT_APP_SECRETKEY).toString();
      return encodeURIComponent(ciphertext);
    }
    return null;
  } catch (error) {
    // console.error('Encryption error:', error);
    return null;
  }
};

export const decrypt = (args) => {
  try {
    let plaintext = '';
    if (args) {
      const ciphertext = decodeURIComponent(args); // Remove decodeURIComponent if not URL-encoded
      const bytes = CryptoJS.AES.decrypt(ciphertext, process.env.REACT_APP_SECRETKEY);
      // Check if decryption was successful
      if (bytes.sigBytes > 0) {
        plaintext = bytes.toString(CryptoJS.enc.Utf8);
      } else {
        plaintext = '';
        // Handle decryption failure, e.g., throw an error or return an appropriate value
        // console.error('Decryption failed');
      }
    }
    return plaintext;
  } catch (error) {
    // console.error('Encryption error:', error);
    return null;
  }
};

function encryptAES(data, key) {
  // Match C# behavior: key must be 16 bytes, so pad with zeros
  const paddedKey = CryptoJS.enc.Utf8.parse(
    key.padEnd(16, "\0")
  );

  // IV = 16 bytes of zeros (same as C# new byte[16])
  const iv = CryptoJS.enc.Utf8.parse("\0".repeat(16));

  const encrypted = CryptoJS.AES.encrypt(data, paddedKey, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return encrypted.toString(); // Base64
}

export function encryptionByAES(field) {
  const key = "qAxKLDMOjKieF2nNODMVjB==";

  const encryptedData = encryptAES(field, key);

  // React equivalent of HttpUtility.UrlEncode
  return encodeURIComponent(encryptedData);
}